export const DEFAULT_LIST_PAGE_SIZE = 30;

export const LIST_PAGE_SIZE_OPTIONS = [10, 20, 30, 50, 100];
